import logger from '../../Utility/logger';

const blackListErrorCodes = [400, 404, 412, 417];
const blackListAPIFailures = ['SIGNAL/GET_USER_ADDRESS_API/FAILURE',];

const errorMiddleware = (store) => (next) => (action) => {
  if (
    action?.type?.indexOf('FAILURE') > 0 &&
    !blackListErrorCodes.includes(action?.data?.errorCode) &&
    !blackListAPIFailures.includes(action?.type) &&
    Object?.keys(action?.data || {})?.length > 0
  ) {
    logger.error('Error captured in Error Middleware', action);
  }

  next(action);
};

export default errorMiddleware;
